<section
  class="flex flex-col gap-8 rounded-[--tui-radius-l] bg-background-neutral-1 p-8 text-center md:p-12"
>
  <h2 class="text-3xl font-bold md:text-4xl">Ready to get started?</h2>
  <p class="text-balance text-xl">
    Integrate the Live Update SDK in less than 5 minutes. Check out our docs,
    explore our GitHub example project and start deploying updates in real-time
    to your Capacitor app today.
  </p>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col justify-center gap-4 sm:flex-row">
      <a
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="consoleBaseUrl"
        target="_blank"
        data-umami-event="live-updates-cta-start-free-button"
      >
        Start for free
      </a>
      <a
        appearance="outline"
        size="l"
        tuiAppearanceMode="checked"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="live-updates-cta-booking-demo-button"
      >
        Book a demo
      </a>
    </div>
    <p class="text-text-tertiary text-sm">
      Questions?
      <a
        class="text-primary hover:underline"
        [href]="discordUrl"
        target="_blank"
      >
        Join our Discord
      </a>
      or
      <a class="text-primary hover:underline" routerLink="/contact/">
        contact us </a
      >.
    </p>
  </div>
</section>
